<template>
  <!-- Global notification live region, render this permanently at the end of the document -->
  <div
    v-if="alerts.length > 0"
    aria-live="assertive"
    class="flex fixed inset-y-14 inset-x-0 z-100 sm:justify-end items-end sm:items-start sm:p-6 py-6 px-4 pointer-events-none"
  >
    <transition-group class="flex flex-col items-center sm:items-end space-y-4 w-full">
      <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
      <div
        v-for="(item) in alerts"
        :key="item.id"
        class="overflow-hidden w-full max-w-sm bg-white rounded-lg ring-1 ring-black ring-opacity-5 shadow-lg pointer-events-auto"
      >
        <div class="p-4">
          <div class="flex items-start">
            <div
              v-if="item.icon"
              class="flex-shrink-0"
            >
              <div class="flex justify-center items-center w-6 h-6">
                <i :class="item.icon" />
              </div>
              <!--                  <CheckCircleIcon class="h-6 w-6 text-green-400" aria-hidden="true" />-->
            </div>
            <div class="flex-1 pt-0.5 ml-3 w-0">
              <p class="text-sm font-medium text-gray-900">
                {{ item.title }}
              </p>
              <p
                v-if="item.description"
                class="mt-1 text-sm text-gray-500"
              >
                {{ item.description }}
              </p>
            </div>
            <div class="flex flex-shrink-0 ml-4">
              <button
                class="inline-flex text-gray-400 hover:text-gray-500 bg-white rounded-md focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-none"
                @click="show = false"
              >
                <span class="sr-only">Close</span>
                <!--                    <XIcon class="h-5 w-5" aria-hidden="true" />-->
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { useUiDialog } from "./useUiDialog";

export default defineComponent({
  name: "UiDialog",
  setup() {
    const {
      alerts,
      info,
    } = useUiDialog();

    return {
      alerts,
      info,
    }
  },
});
</script>

<style scoped>

</style>
